import {FormEvent, useState} from "react";
import {Button, Col, Container, Form, FormGroup, Input, Row} from "reactstrap";
import {CONTACT_DETAILS, PUBLIC_SOCIAL_LINKS} from "./utils";
import {useGetPublicUserTypesQuery, useSaveContactMutation} from "../../store/services/publicApi";


export const AboutContact = () => {
    const EMPTY_FORM = {
        fullName: '',
        email: '',
        message: '',
        role: ''
    }
    const [formData, setFormData] = useState(EMPTY_FORM);
    const [saveContact, {isLoading}] = useSaveContactMutation()

    const { data, isLoading: publicUserTypesLoading } = useGetPublicUserTypesQuery({});

    const handleChange = (e: any) => {
        const {name, value} = e.target;
        setFormData(prev => ({...prev, [name]: value}));
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        if (isLoading) return;

        const result = await saveContact({
            full_name: formData.fullName,
            email: formData.email,
            message: formData.message,
            user_type_id: formData.role,
        })
        if (result.data?.id) {
            alert("Thank you! Your request has been sent.");
            setFormData(EMPTY_FORM);
        } else {
            alert("Something went wrong please try again later.");
        }
    };

    return (
        <section className="py-7" aria-labelledby="contacts" id="contact">
            <Container>
                {/* Section Header */}
                <div className="text-center mb-5">
                    <h2 className="display-3 text-primary font-weight-bold">Contact us</h2>
                    <p className="mx-auto" style={{maxWidth: '600px'}}>
                        Whether you’re interested in partnerships, media inquiries, or
                        anything else, feel free to reach out using the contact form below.
                    </p>
                </div>

                {/* Main Card-like Wrapper */}
                <div className="mx-auto border p-2 p-md-4 shadow-sm">
                    <Row className="no-gutters">

                        {/* Left Side: Contact Info with Background */}
                        <Col md="6" className="overflow-hidden d-flex flex-column py-5 px-4 position-relative"
                             style={{
                                 backgroundImage: 'url("/public/contact%20section%20image.webp")',
                                 backgroundPosition: 'center',
                                 minHeight: '400px'
                             }}>

                            <div className="position-relative d-flex flex-column h-100">
                                <ul className="list-unstyled flex-grow-1 d-flex flex-column justify-content-center">
                                    {CONTACT_DETAILS.map((item) => (
                                        <li key={item.label} className="mb-4">
                                            <small
                                                className="text-warning text-uppercase font-weight-bold ls-1 d-block mb-1">
                                                {item.label}
                                            </small>
                                            <a href={item.href}
                                               className="h4 text-white font-weight-500 text-wrap hover:text-warning transition-inner">
                                                {item.value}
                                            </a>
                                        </li>
                                    ))}
                                </ul>

                                <div className="text-center mt-auto">
                                    <p className="text-white opacity-8 mb-2">Stay in touch with us</p>
                                    <div className="d-flex justify-content-center align-items-center">
                                        {PUBLIC_SOCIAL_LINKS.map((icon) => (
                                            <a key={icon.href} href={icon.href}>
                                                <img key={icon.name} src={icon.src} alt={icon.name} style={icon.style}
                                                     className="mx-2"/>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* Right Side: Controlled Form */}
                        <Col md="6" className="p-4">
                            <Form onSubmit={handleSubmit} aria-disabled={publicUserTypesLoading}>
                                <FormGroup className="mb-3">
                                    <label className="form-control-label text-muted small ml-1">What should we call
                                        you</label>
                                    <Input
                                        id="fullName"
                                        name="fullName"
                                        type="text"
                                        placeholder="Your full name"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        className="form-control-alternative"
                                        required
                                    />
                                </FormGroup>

                                <FormGroup className="mb-3">
                                    <label className="form-control-label text-muted small ml-1">How to contact
                                        you</label>
                                    <Input
                                        id="email"
                                        name="email"
                                        type="email"
                                        placeholder="Your email or phone"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="form-control-alternative"
                                        required
                                    />
                                </FormGroup>

                                <FormGroup className="mb-3">
                                    <label className="form-control-label text-muted small ml-1">What's your
                                        Message</label>
                                    <Input
                                        id="message"
                                        name="message"
                                        type="textarea"
                                        rows="4"
                                        placeholder="Your message..."
                                        value={formData.message}
                                        onChange={handleChange}
                                        className="form-control-alternative"
                                        style={{resize: 'none'}}
                                        required
                                    />
                                </FormGroup>

                                <FormGroup className="mb-4">
                                    <label className="form-control-label text-muted small ml-1">You are?</label>
                                    <Input
                                        type="select"
                                        name="role"
                                        id="role"
                                        value={formData.role}
                                        onChange={handleChange}
                                        className="form-control-alternative"
                                    >
                                        {data?.map(item => (
                                            <option key={item.id} value={item.id}>{item.type}</option>
                                        ))}
                                    </Input>
                                </FormGroup>

                                <Button
                                    block
                                    type="submit"
                                    color="default"
                                    disabled={isLoading}
                                    className="btn-primary text-white shadow-none"
                                >
                                    Send
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    );
};